import React from "react";
import { FaLinkedinIn, FaQuoteLeft } from "react-icons/fa";
import Services18 from "../images/shirish.jpg";
import bgImage    from "../images/arjit.jpeg";
import bgImage1   from "../images/t22.jpg";

/* ── Constants ─────────────────────────────────────── */
const LEADERS = [
  {
    key:         "shirish",
    name:        "Shirish Tulsian",
    role:        "Founder & CEO",
    credentials: "Oxford MBA",
    desc:        "With an Oxford MBA and years of enterprise leadership, Shirish architects the strategic vision of Skywise Technologies — driving innovation across mining, logistics, and AI-powered digital transformation.",
    image:       Services18,
    linkedin:    "https://linkedin.com/in/shirishtulsian",
    accent:      "#2563eb",
    accentBg:    "rgba(37,99,235,0.12)",
  },
  {
    key:         "arjit",
    name:        "Arjit Dutta",
    role:        "Co-Founder & COO",
    credentials: "Technology & Operations",
    desc:        "Arjit brings deep expertise in software engineering and operational excellence, ensuring every product Skywise delivers is scalable, reliable, and precisely aligned with client outcomes.",
    image:       bgImage,
    linkedin:    "https://www.linkedin.com/in/arjit-dutta-738b2564/?skipRedirect=true",
    accent:      "#0891b2",
    accentBg:    "rgba(8,145,178,0.12)",
  },
];

/* ── Component ─────────────────────────────────────── */
function LeadershipTeam() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@400;500;600&display=swap');

        .lt-section {
          position: relative;
          padding: 5rem 0;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          font-family: 'DM Sans', sans-serif;
          overflow: hidden;
        }

        /* dark overlay */
        .lt-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            160deg,
            rgba(6,12,34,0.93) 0%,
            rgba(10,22,60,0.88) 100%
          );
        }

        /* subtle grid texture */
        .lt-grid-texture {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px);
          background-size: 48px 48px;
          pointer-events: none;
        }

        /* glow blobs */
        .lt-glow-left {
          position: absolute;
          top: -80px; left: -60px;
          width: 380px; height: 380px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(37,99,235,0.18) 0%, transparent 70%);
          pointer-events: none;
        }
        .lt-glow-right {
          position: absolute;
          bottom: -80px; right: -60px;
          width: 320px; height: 320px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(8,145,178,0.15) 0%, transparent 70%);
          pointer-events: none;
        }

        .lt-inner {
          position: relative;
          z-index: 1;
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 1.5rem;
        }

        /* ── Section header ── */
        .lt-header { text-align: center; margin-bottom: 3.5rem; }

        .lt-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          font-size: 0.74rem;
          font-weight: 700;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: #60a5fa;
          background: rgba(96,165,250,0.1);
          border: 1px solid rgba(96,165,250,0.22);
          padding: 0.3rem 0.95rem;
          border-radius: 50px;
          margin-bottom: 1rem;
        }
        .lt-eyebrow::before {
          content: '';
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #60a5fa;
          animation: lt-pulse 1.8s infinite;
        }
        @keyframes lt-pulse {
          0%,100% { opacity:1; transform:scale(1);   }
          50%      { opacity:.4; transform:scale(.7); }
        }

        .lt-title {
          font-family: 'Syne', sans-serif;
          font-size: clamp(1.8rem, 4vw, 2.6rem);
          font-weight: 800;
          color: #fff;
          margin: 0 0 0.75rem;
          line-height: 1.15;
        }
        .lt-title span {
          background: linear-gradient(90deg, #60a5fa, #a78bfa);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .lt-subtitle {
          font-size: 1rem;
          color: rgba(255,255,255,0.6);
          max-width: 560px;
          margin: 0 auto;
          line-height: 1.7;
        }

        /* ── Cards grid ── */
        .lt-grid {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 2rem;
        }

        /* ── Leader card ── */
        .lt-card {
          flex: 1 1 340px;
          max-width: 440px;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 18px;
          padding: 2.25rem 2rem 1.75rem;
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          position: relative;
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
        }
        .lt-card::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 3px;
          background: var(--card-accent, #2563eb);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.35s ease;
        }
        .lt-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 50px rgba(0,0,0,0.4);
          border-color: rgba(255,255,255,0.2);
        }
        .lt-card:hover::before { transform: scaleX(1); }

        /* quote icon watermark */
        .lt-quote-mark {
          position: absolute;
          top: 1.25rem; right: 1.5rem;
          font-size: 2.5rem;
          color: var(--card-accent, #2563eb);
          opacity: 0.15;
          pointer-events: none;
        }

        /* ── Avatar ── */
        .lt-avatar-wrap {
          display: flex;
          align-items: center;
          gap: 1.25rem;
          margin-bottom: 1.25rem;
        }
        .lt-avatar-ring {
          width: 80px; height: 80px;
          border-radius: 50%;
          border: 3px solid var(--card-accent, #2563eb);
          box-shadow: 0 0 0 4px var(--card-accent-bg, rgba(37,99,235,0.12));
          overflow: hidden;
          flex-shrink: 0;
          transition: box-shadow 0.3s ease;
        }
        .lt-card:hover .lt-avatar-ring {
          box-shadow:
            0 0 0 6px var(--card-accent-bg, rgba(37,99,235,0.2)),
            0 0 24px var(--card-accent, #2563eb);
        }
        .lt-avatar-ring img {
          width: 100%; height: 100%;
          object-fit: cover; display: block;
        }

        /* name / role block */
        .lt-name {
          font-family: 'Syne', sans-serif;
          font-size: 1.15rem;
          font-weight: 700;
          color: #fff;
          margin: 0 0 0.2rem;
          line-height: 1.2;
        }
        .lt-role {
          font-size: 0.82rem;
          font-weight: 600;
          color: var(--card-accent, #2563eb);
          margin-bottom: 0.2rem;
          letter-spacing: 0.02em;
        }
        .lt-credentials {
          display: inline-flex;
          align-items: center;
          gap: 0.3rem;
          font-size: 0.7rem;
          font-weight: 600;
          letter-spacing: 0.07em;
          text-transform: uppercase;
          color: rgba(255,255,255,0.45);
          background: rgba(255,255,255,0.07);
          border: 1px solid rgba(255,255,255,0.1);
          padding: 0.18rem 0.65rem;
          border-radius: 50px;
          margin-top: 0.15rem;
        }

        /* ── Divider ── */
        .lt-card-divider {
          border: none;
          border-top: 1px solid rgba(255,255,255,0.08);
          margin: 1.1rem 0;
        }

        /* ── Description ── */
        .lt-desc {
          font-size: 0.88rem;
          color: rgba(255,255,255,0.65);
          line-height: 1.75;
          margin-bottom: 1.35rem;
        }

        /* ── LinkedIn button ── */
        .lt-linkedin {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.45rem 1rem;
          border-radius: 7px;
          border: 1px solid rgba(255,255,255,0.15);
          background: rgba(255,255,255,0.06);
          color: rgba(255,255,255,0.75);
          font-size: 0.8rem;
          font-weight: 600;
          text-decoration: none;
          font-family: 'DM Sans', sans-serif;
          transition: background 0.2s, border-color 0.2s, color 0.2s, transform 0.2s;
        }
        .lt-linkedin svg { font-size: 0.85rem; color: #60a5fa; }
        .lt-linkedin:hover {
          background: rgba(96,165,250,0.15);
          border-color: rgba(96,165,250,0.4);
          color: #fff;
          transform: translateY(-2px);
        }

        /* ── Responsive ── */
        @media (max-width: 768px) {
          .lt-section  { padding: 3.5rem 0; }
          .lt-card     { padding: 1.75rem 1.5rem 1.5rem; }
          .lt-grid     { gap: 1.5rem; }
        }
        @media (max-width: 480px) {
          .lt-card        { flex: 1 1 100%; max-width: 100%; }
          .lt-avatar-ring { width: 68px; height: 68px; }
          .lt-title       { font-size: 1.7rem; }
        }
      `}</style>

      <section
        className="lt-section"
        style={{ backgroundImage: `url(${bgImage1})` }}
        aria-labelledby="lt-heading"
      >
        <div className="lt-overlay"      aria-hidden="true" />
        <div className="lt-grid-texture" aria-hidden="true" />
        <div className="lt-glow-left"    aria-hidden="true" />
        <div className="lt-glow-right"   aria-hidden="true" />

        <div className="lt-inner">

          {/* ── Header ── */}
          <div className="lt-header">
            <span className="lt-eyebrow">Leadership</span>
            <h2 className="lt-title" id="lt-heading">
              Meet the <span>Visionaries</span>
            </h2>
            <p className="lt-subtitle">
              The people driving strategy, innovation, and execution at
              Skywise Technologies — committed to delivering transformative
              technology for every client.
            </p>
          </div>

          {/* ── Cards ── */}
          <div className="lt-grid" role="list">
            {LEADERS.map((leader) => (
              <article
                key={leader.key}
                className="lt-card"
                role="listitem"
                style={{
                  "--card-accent":    leader.accent,
                  "--card-accent-bg": leader.accentBg,
                }}
              >
                {/* decorative quote watermark */}
                <FaQuoteLeft className="lt-quote-mark" aria-hidden="true" />

                {/* Avatar + identity */}
                <div className="lt-avatar-wrap">
                  <div className="lt-avatar-ring">
                    <img
                      src={leader.image}
                      alt={`Portrait of ${leader.name}`}
                    />
                  </div>
                  <div>
                    <div className="lt-name">{leader.name}</div>
                    <div className="lt-role">{leader.role}</div>
                    <span className="lt-credentials">{leader.credentials}</span>
                  </div>
                </div>

                <hr className="lt-card-divider" />

                {/* Bio */}
                <p className="lt-desc">{leader.desc}</p>

                {/* LinkedIn CTA */}
                <a
                  href={leader.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lt-linkedin"
                  aria-label={`View ${leader.name}'s LinkedIn profile (opens in new tab)`}
                >
                  <FaLinkedinIn />
                  LinkedIn Profile
                </a>
              </article>
            ))}
          </div>

        </div>
      </section>
    </>
  );
}

export default LeadershipTeam;